import React from 'react'
import { Spacer } from '../../../ui/atoms'
import SModal from '../../../ui/molecules/SModal'
import {
  MESSAGE_TYPE,
  useMessage,
} from '../../../utils/helpers/MessageProvider'
import { Linking, Text } from 'react-native'
import { Divider } from 'react-native-paper'
import { commonColors } from '../../../../../common-frontend/src/theme'
import { IconPaid } from '../../../assets/icons'
import { invoiceStatus } from '@linqpal/models/src/dictionaries'
import { useTranslation } from 'react-i18next'

function prepareAlertMessages(statusData, t) {
  if (statusData?.invoiceStatus === invoiceStatus.cancelled) {
    return [
      t('invoiceAlert.cancelled'),
      t('invoiceAlert.contact-supplier'),
      true,
    ]
  }
  if (statusData?.invoiceStatus === invoiceStatus.dismissed) {
    return [
      t('invoiceAlert.dismissed'),
      t('invoiceAlert.contact-supplier'),
      true,
    ]
  }

  if (statusData?.invoiceStatus === invoiceStatus.expired) {
    return [t('invoiceAlert.expired'), t('invoiceAlert.contact-supplier'), true]
  }
  if (
    statusData?.invoiceStatus === invoiceStatus.paid ||
    statusData?.invoiceStatus === invoiceStatus.paymentPosted ||
    statusData?.invoiceStatus === invoiceStatus.paymentProcessing ||
    statusData?.invoiceStatus === invoiceStatus.collected
  ) {
    return [
      <IconPaid width={28} height={28} style={{ marginBottom: 12 }} />,
      t('invoiceAlert.paid'),
    ]
  }
  if (!statusData?.cardPaymentAvailable) {
    return [
      t('invoiceAlert.choose-different-payment-title'),
      t('invoiceAlert.choose-different-payment-message'),
      true,
    ]
  }
  return ['', '']
}

export const InvoiceAlert = ({
  statusData,
  onClose,
  visible,
  invoice,
  customLabel,
}) => {
  const { setMessage } = useMessage()
  const { t } = useTranslation('global')
  const [msg1, msg2, showCallButton = false] = prepareAlertMessages(
    statusData,
    t,
  )
  return (
    <SModal
      backDropAction={false}
      onClose={onClose}
      visible={visible && (msg1 || msg2)}
      containerStyle={{ padding: 0 }}
      contentStyle={{ padding: 0 }}
    >
      <Spacer />
      <Spacer />
      <Text
        style={{
          fontWeight: 'bold',
          marginBottom: 3,
          width: '100%',
          textAlign: 'center',
          paddingHorizontal: 10,
          fontSize: 16,
        }}
      >
        {msg1}
      </Text>
      <Spacer height={20} />
      <Text
        style={{
          fontWeight: !msg1 || typeof msg1 !== 'string' ? 'bold' : 'normal',
          width: '100%',
          textAlign: 'center',
          lineHeight: 24,
          paddingHorizontal: 10,
          fontSize: 14,
        }}
      >
        {msg2}
      </Text>
      <Spacer />
      <Spacer />
      {showCallButton && (
        <>
          <Divider />
          <Spacer />
          <Text
            style={{
              color: commonColors.accentText,
              fontWeight: '500',
              fontSize: 17,
              width: '100%',
              textAlign: 'center',
              paddingHorizontal: 10,
            }}
            onPress={() => {
              if (invoice.company.phone) {
                Linking.openURL(`tel:${invoice.company.phone}`)
              } else {
                setMessage(MESSAGE_TYPE.WARNING, t('invoiceAlert.no-phone'))
              }
              onClose()
            }}
          >
            {t('invoiceAlert.call-supplier')}
          </Text>
        </>
      )}
      <Spacer />
      <Divider />
      <Spacer />
      <Text
        style={{
          color: commonColors.accentText,
          fontSize: 17,
          fontWeight: '400',
          width: '100%',
          textAlign: 'center',
          paddingHorizontal: 10,
        }}
        onPress={onClose}
      >
        {customLabel || t('close')}
      </Text>
      <Spacer />
    </SModal>
  )
}
